<template>
  <div class="chats">
    <div
      v-for="(msgGrp, index) in formattedChatData.formattedChatLog"
      :key="msgGrp.senderId+String(index)"
      class="chat"
      :class="{'chat-left': msgGrp.sender !== formattedChatData.user.email}"
    >
      <div class="chat-avatar">
        <b-avatar
          v-if="msgGrp.sender === formattedChatData.contact.email"
          size="36"
          class="avatar-border-2 box-shadow-1"
          variant="transparent"
          :src="formattedChatData.contact.avatar"
        />
        <b-avatar
          v-if="msgGrp.sender === formattedChatData.contact2.email"
          size="36"
          class="avatar-border-2 box-shadow-1"
          variant="transparent"
          :src="formattedChatData.contact2.avatar"
        />
        <b-avatar
          v-if="msgGrp.sender === formattedChatData.user.email"
          size="36"
          class="avatar-border-2 box-shadow-1"
          variant="transparent"
          :src="formattedChatData.user.avatar"
        />
      </div>
      <div class="chat-body">
        <div
          v-for="msgData in msgGrp.messages"
          :key="msgData.time"
          class="chat-content"
        >
          <p>{{ msgData.msg }}</p>
          <small class="float-right chat-time"  v-if="msgGrp.sender !== formattedChatData.user.email">{{ msgData.sender.first_name }} {{ msgData.sender.last_name }}, {{ formatDateToMonthShort(msgData.time, { hour: 'numeric', minute: 'numeric' }) }}</small>
          <small v-else>{{ formatDateToMonthShort(msgData.time, { hour: 'numeric', minute: 'numeric' }) }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { BAvatar } from 'bootstrap-vue'
import { formatDateToMonthShort } from '@core/utils/filter'

export default {
  components: {
    BAvatar,
  },
  props: {
    chatData: {
      type: Object,
      required: true,
    },
    profileUserAvatar: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const formattedChatData = computed(() => {
      const contact = {
        id: props.chatData.contacts[0].id,
        email: props.chatData.contacts[0].email,
        avatar: props.chatData.contacts[0].avatar,
      }

      const contact2 = {
        id: props.chatData.contacts[1].id,
        email: props.chatData.contacts[1].email,
        avatar: props.chatData.contacts[1].avatar,
      }

      const user = {
        id: props.chatData.user.id,
        avatar: props.chatData.user.avatar,
        email: props.chatData.user.email
      }

      let chatLog = []
      if (props.chatData.data) {
        chatLog = props.chatData.data
      }

      const formattedChatLog = []
      let chatMessageSenderId = chatLog[0] ? chatLog[0].sender.email : undefined
      let msgGroup = {
        sender: chatMessageSenderId,
        messages: [],
      }

      // console.log(props.chatData)

      chatLog.forEach((msg, index) => {
        if (chatMessageSenderId === msg.sender.email) {
          msgGroup.messages.push({
            msg: msg.body,
            time: msg.updated_at,
            sender: msg.sender
          })
        } else {
          chatMessageSenderId = msg.sender.email
          
          formattedChatLog.push(msgGroup)
          msgGroup = {
            sender: msg.sender.email,
            messages: [{
              msg: msg.body,
              time: msg.updated_at,
              sender: msg.sender
            }],
          }
        }
        if (index === chatLog.length - 1) formattedChatLog.push(msgGroup)
      })

      return {
        formattedChatLog,
        contact,
        contact2,
        user,
        profileUserAvatar: props.profileUserAvatar,
      }
    })

    return {
      formattedChatData,
      formatDateToMonthShort,
    }
  },
}
</script>

<style>

</style>
